export default function() {
    this.$store.commit('stopLoading');
}
